import { useEffect } from 'react';
import { getBrandsThunk } from '../api/brands';
import { useAppDispatch } from '../redux/store';

export const useBrandsData = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBrandsThunk());
  }, [dispatch]);
};
